import { Pipe, PipeTransform } from '@angular/core';
import { HtmlSanitizerService } from '../service/html-sanitizer-service';

@Pipe({
  name: 'htmlSanitizer'
})
export class HtmlSanitizerPipe implements PipeTransform {
  constructor(private sanitizerService: HtmlSanitizerService) { }

  transform(value: any): any {
    return this.sanitizerService.sanitizeHtml(value);
  }

}
